import { getEnumValues } from './get-enum-values';

export enum SoccerGameOccurenceType {
	Goal= 'Goal',
	Substitution = 'Substitution',
	YellowCard = 'Yellow Card',
	RedCard = 'Red Card',
}

export const SoccerGameOccurenceTypeValues = getEnumValues <SoccerGameOccurenceType>(SoccerGameOccurenceType)